module.exports = __webpack_public_path__ + "media/images/logos/ace-4abcaa0b0d580a0fd3fd01c9f97ec64c.png";